import { useContext } from "react";
import { Col, Container, Input, Label, Row } from "reactstrap";
import ReportDownloadSentContext from "../../../context/ReportDownloadSentContext/ReportDownloadSentContext";
import { maxLengthCheck } from "../../../../utils/helper";

const ReportDownloadSentParentPopup = (props) => {
  const { simpleValidator } = props;
  const { isEdit, formDataParent, setFormDataParent } = useContext(
    ReportDownloadSentContext
  );

  const changeFormValue = (e) => {
    const { value, name, checked } = e.target;

    setFormDataParent((prev) => {
      if (name === "isTitleShow") {
        return {
          ...prev,
          [name]: checked,
        };
      } else {
        return {
          ...prev,
          [name]: value,
        };
      }
    });
  };

  return (
    <Container className="mb-5">
      <Row>
        <Col sm="12" xl="12">
          <div className="mt-4 d-flex flex-column justify-content-center ">
            <h6>{isEdit ? "Edit" : "Add New"}</h6>
            <Row className="mt-4">
              <Col md="12 mb-3">
                <Label htmlFor="validationCustom03">{"Title *"}</Label>
                <Input
                  className="form-control"
                  name="name"
                  type="text"
                  placeholder="Title"
                  value={formDataParent?.name}
                  onChange={(e) => changeFormValue(e)}
                  style={{ borderRadius: "0", color: "black" }}
                />
                <p style={{ color: "red" }}>
                  {simpleValidator.current.message(
                    "Name",
                    formDataParent.name,
                    "required"
                  )}
                </p>
              </Col>
              <Col md="12 mb-3">
                <Label htmlFor="validationCustom03">{"Sub Title"}</Label>
                <Input
                  className="form-control"
                  name="email"
                  type="text"
                  placeholder="Sub Title"
                  value={formDataParent?.email}
                  onChange={(e) => changeFormValue(e)}
                  style={{ borderRadius: "0", color: "black" }}
                />
                <p style={{ color: "red" }}>
                  {simpleValidator.current.message(
                    "Sub Title",
                    formDataParent.email,
                    "required"
                  )}
                </p>
              </Col>{" "}
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ReportDownloadSentParentPopup;
